import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

import { UpdateVehicleForm } from "../../UpdateVehicleForm";

function toFormVehicle(vehicle) {
  return {
    ...vehicle,
    ...vehicle.pendingChange?.proposed,
    owner_dni: vehicle.ownerDni ?? "",
    owner_address: vehicle.ownerAddress ?? "",
    tr_description: vehicle.technicalReview?.description ?? "",
    tr_end: vehicle.technicalReview?.end ?? null,
    soat_description: vehicle.soat?.description ?? "",
    soat_end: vehicle.soat?.end ?? null,
    setare_permission: vehicle.setare?.permission ?? false,
    setare_start: vehicle.setare?.start ?? null,
    setare_end: vehicle.setare?.end ?? null,
  };
}

const fieldLabels = {
  brand: "Marca",
  model: "Modelo",
  bodywork: "Carrocería",
  plate: "Placa",
  year: "Año",
  color: "Color",
  owner: "Propietario",
  cylinder: "Cilindrada",
  weight: "Peso",
};

function displayValue(value) {
  return value === null || value === undefined || value === ""
    ? "—"
    : String(value);
}

export function RenewVehicleModal({ vehicle, onClose }) {
  return (
    <Dialog
      open={Boolean(vehicle)}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      scroll="paper"
      sx={(theme) => ({
        "& .MuiDialog-paper": {
          [theme.breakpoints.down("sm")]: {
            m: 0,
            width: "100%",
            maxWidth: "100%",
          },
        },
      })}
    >
      <DialogTitle
        sx={{
          bgcolor: "#f4faf7",
          borderBottom: "1px solid rgba(20, 83, 45, 0.12)",
        }}
      >
        <Typography variant="h6" sx={{ color: "#12483f", fontWeight: 800 }}>
          VEHÍCULO {vehicle?.plate || ""}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ p: { xs: 1, md: 2 } }}>
        {vehicle && (
          <>
            <Box sx={{ px: { xs: 1, md: 2 }, pt: 2 }}>
              <Typography variant="subtitle1" fontWeight={700}>
                Cambio propuesto
              </Typography>
              {Array.isArray(vehicle.pendingChange?.changes) ? (
                vehicle.pendingChange.changes.length ? (
                  <Stack spacing={1} sx={{ mt: 1 }}>
                    {vehicle.pendingChange.changes.map(
                      ({ field, before, after }) => (
                        <Box key={field} sx={{ p: 1.5, borderRadius: 2 }}>
                          <Typography variant="body2" fontWeight={700}>
                            {fieldLabels[field] || field}
                          </Typography>
                          <Typography variant="body2">
                            {displayValue(before)} → {displayValue(after)}
                          </Typography>
                        </Box>
                      ),
                    )}
                  </Stack>
                ) : (
                  <Typography variant="body2">
                    No se registraron diferencias.
                  </Typography>
                )
              ) : (
                <Typography variant="body2">
                  Solicitud heredada sin comparación de valores anteriores.
                </Typography>
              )}
              <Typography variant="body2" sx={{ mt: 2 }}>
                Datos propuestos del vehículo y documentos actuales
              </Typography>
            </Box>
            <UpdateVehicleForm
              key={vehicle.pendingChange?.requestId ?? vehicle.id}
              vehicle={toFormVehicle(vehicle)}
              readOnly
            />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Box>
          <Button variant="contained" color="error" onClick={onClose}>
            Cerrar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
